import { defineProperty as _defineProperty, toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { createStyles } from '@mantine/styles';
import { addBreakpointMedia, objectDeepMerging, ThemeBreakpoints, isString } from '../../utils/index.js';
import { RootVariable } from './constant.js';
import { useSelectAppTargetStyle } from './GateSelect.app.style.js';

var _defaultVariable, _defaultVariableInDro;
var resetVariable = Object.values(RootVariable).reduce(function (ac, cr) {
  ac[cr] = 'none';
  return ac;
}, {});
var defaultVariable = (_defaultVariable = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultVariable, RootVariable.SELECT_FONT_WEIGHT, 500), RootVariable.SELECT_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_ICON_COLOR, 'var(--gui-color-icon-1)'), RootVariable.SELECT_FOCUS_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_HOVER_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_ACTIVE_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_INVALID_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_DISABLED_COLOR, 'var(--gui-color-text-7)'), RootVariable.SELECT_DISABLED_BG, 'var(--gui-color-cmpt-2)'), RootVariable.SELECT_PLACEHOLDER_COLOR, 'var(--gui-color-text-3)'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultVariable, RootVariable.SELECT_DISABLED_PLACEHOLDER_COLOR, 'var(--gui-color-text-7)'), RootVariable.SELECT_INVALID_PLACEHOLDER_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_PLACEHOLDER_FONT_WEIGHT, 500), RootVariable.SELECT_ICON_SAFE_GAP, '8px'), RootVariable.SELECT_DISABLED_ICON_COLOR, 'var(--gui-color-icon-7)'), RootVariable.SELECT_RIGHT_SECTION_SAFE_GAP, '8px'), RootVariable.SELECT_HOVER_RIGHT_SECTION_COLOR, 'var(--gui-color-icon-1)'), RootVariable.SELECT_ACTIVE_RIGHT_SECTION_COLOR, 'var(--gui-color-icon-5)'), RootVariable.SELECT_DISABLED_RIGHT_SECTION_COLOR, 'var(--gui-color-icon-7)'), RootVariable.SELECT_RIGHT_SECTION_COLOR, 'var(--gui-color-icon-1)'));
var defaultVariableInDropdown = (_defaultVariableInDro = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultVariableInDro, RootVariable.SELECT_DROPDOWN_BG, 'var(--gui-color-card-3)'), RootVariable.SELECT_DROPDOWN_RADIUS, '6px'), RootVariable.SELECT_DROPDOWN_PADDING, '8px'), RootVariable.SELECT_DROPDOWN_BOTTOM_SAFE_GAP, '6px'), RootVariable.SELECT_ITEM_ACTIVE_ICON_SIZE, '16px'), RootVariable.SELECT_ITEM_HOVER_BG, 'var(--gui-color-neutral-2)'), RootVariable.SELECT_ITEM_SELECTED_BG, 'transparent'), RootVariable.SELECT_ITEM_SELECTED_COLOR, 'var(--gui-color-text-5)'), RootVariable.SELECT_ITEM_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_ITEM_HOVER_COLOR, 'var(--gui-color-text-1)'), _defineProperty(_defineProperty(_defineProperty(_defaultVariableInDro, RootVariable.SELECT_ITEM_COL_GAP, '2px'), RootVariable.SELECT_ITEM_RADIUS, '4px'), RootVariable.SELECT_ITEM_ACTIVE_ICON_SAFE_GAP, '8px'));
var getDefaultStyles = function getDefaultStyles() {
  return {
    root: _objectSpread2(_objectSpread2({}, resetVariable), defaultVariable),
    dropdown: _objectSpread2({}, defaultVariableInDropdown)
  };
};
var getPrimaryStyles = function getPrimaryStyles() {
  var _root;
  return {
    root: (_root = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_root, RootVariable.SELECT_BG, 'var(--gui-color-neutral-7)'), RootVariable.SELECT_HOVER_BG, 'var(--gui-color-neutral-7)'), RootVariable.SELECT_ACTIVE_BG, 'var(--gui-color-neutral-7)'), RootVariable.SELECT_DISABLED_BG, 'var(--gui-color-cmpt-25)'), RootVariable.SELECT_INVALID_BG, 'var(--gui-color-neutral-7)'), RootVariable.SELECT_BORDER_WIDTH, '1px'), RootVariable.SELECT_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.SELECT_HOVER_BORDER_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_ACTIVE_BORDER_COLOR, 'var(--gui-color-text-1)'), RootVariable.SELECT_INVALID_BORDER_COLOR, 'var(--gui-color-funct-3)'), _defineProperty(_defineProperty(_root, RootVariable.SELECT_DISABLED_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.SELECT_RIGHT_SECTION_COLOR, 'var(--gui-color-icon-3)'))
  };
};
var getOutlinedStyles = function getOutlinedStyles() {
  var _root2;
  return {
    root: (_root2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_root2, RootVariable.SELECT_HOVER_BORDER_COLOR, 'var(--gui-color-text-9)'), RootVariable.SELECT_ACTIVE_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.SELECT_INVALID_BORDER_COLOR, 'var(--gui-color-funct-3)'), RootVariable.SELECT_DISABLED_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.SELECT_BORDER_WIDTH, '1px'), RootVariable.SELECT_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.SELECT_FOCUS_BORDER_COLOR, 'var(--gui-color-divider-5)'), RootVariable.SELECT_BG, 'transparent'), RootVariable.SELECT_HOVER_BG, 'transparent'), RootVariable.SELECT_ACTIVE_BG, 'transparent'), _defineProperty(_root2, RootVariable.SELECT_INVALID_BG, 'transparent'))
  };
};
var getLgStyles = function getLgStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_RADIUS, '6px'), RootVariable.SELECT_HEIGHT, '48px'), RootVariable.SELECT_FONT_SIZE, '14px'), RootVariable.SELECT_ICON_SIZE, '20px'), RootVariable.SELECT_PLACEHOLDER_FONT_SIZE, '14px'), RootVariable.SELECT_RIGHT_SECTION_ICON_SIZE, '16px'), RootVariable.SELECT_CLEAR_ICON_SIZE, '20px'), RootVariable.SELECT_BASE_PADDING, '16px'), RootVariable.SELECT_ICON_SAFE_GAP, '8px'),
    dropdown: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_ITEM_HEIGHT, '36px'), RootVariable.SELECT_ITEM_FONT_SIZE, '14px'), RootVariable.SELECT_ITEM_FONT_WEIGHT, 500), RootVariable.SELECT_ITEM_BASE_PADDING, '8px')
  };
};
var getMdStyles = function getMdStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_RADIUS, '6px'), RootVariable.SELECT_HEIGHT, '40px'), RootVariable.SELECT_FONT_SIZE, '14px'), RootVariable.SELECT_ICON_SIZE, '16px'), RootVariable.SELECT_PLACEHOLDER_FONT_SIZE, '14px'), RootVariable.SELECT_RIGHT_SECTION_ICON_SIZE, '16px'), RootVariable.SELECT_CLEAR_ICON_SIZE, '18px'), RootVariable.SELECT_BASE_PADDING, '12px'), RootVariable.SELECT_ICON_SAFE_GAP, '8px'),
    dropdown: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_ITEM_HEIGHT, '36px'), RootVariable.SELECT_ITEM_FONT_SIZE, '14px'), RootVariable.SELECT_ITEM_FONT_WEIGHT, 500), RootVariable.SELECT_ITEM_BASE_PADDING, '8px')
  };
};
var getSmStyles = function getSmStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_RADIUS, '6px'), RootVariable.SELECT_HEIGHT, '32px'), RootVariable.SELECT_FONT_SIZE, '12px'), RootVariable.SELECT_ICON_SIZE, '14px'), RootVariable.SELECT_PLACEHOLDER_FONT_SIZE, '12px'), RootVariable.SELECT_RIGHT_SECTION_ICON_SIZE, '12px'), RootVariable.SELECT_CLEAR_ICON_SIZE, '16px'), RootVariable.SELECT_BASE_PADDING, '8px'), RootVariable.SELECT_ICON_SAFE_GAP, '8px'),
    dropdown: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_ITEM_HEIGHT, '36px'), RootVariable.SELECT_ITEM_FONT_SIZE, '12px'), RootVariable.SELECT_ITEM_FONT_WEIGHT, 500), RootVariable.SELECT_ITEM_BASE_PADDING, '8px')
  };
};
var getXsStyles = function getXsStyles() {
  return {
    root: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_RADIUS, '4px'), RootVariable.SELECT_HEIGHT, '24px'), RootVariable.SELECT_FONT_SIZE, '12px'), RootVariable.SELECT_ICON_SIZE, '14px'), RootVariable.SELECT_PLACEHOLDER_FONT_SIZE, '12px'), RootVariable.SELECT_RIGHT_SECTION_ICON_SIZE, '12px'), RootVariable.SELECT_CLEAR_ICON_SIZE, '16px'), RootVariable.SELECT_BASE_PADDING, '8px'), RootVariable.SELECT_ICON_SAFE_GAP, '8px'),
    dropdown: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RootVariable.SELECT_ITEM_HEIGHT, '36px'), RootVariable.SELECT_ITEM_FONT_SIZE, '12px'), RootVariable.SELECT_ITEM_FONT_WEIGHT, 500), RootVariable.SELECT_ITEM_BASE_PADDING, '8px')
  };
};
var getCurrentVariantAndSizeStyle = function getCurrentVariantAndSizeStyle(_ref) {
  var type = _ref.type,
    size = _ref.size;
  return objectDeepMerging(getDefaultStyles(), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, size === 'lg' ? getLgStyles() : {}), size === 'md' ? getMdStyles() : {}), size === 'sm' ? getSmStyles() : {}), size === 'xs' ? getXsStyles() : {}), _objectSpread2(_objectSpread2({}, type === 'primary' ? getPrimaryStyles() : {}), type === 'outlined' ? getOutlinedStyles() : {}));
};
var useSelectStyle = createStyles(function (_, _ref2, getRef) {
  var size = _ref2.size,
    hasLeft = _ref2.hasLeft,
    breakpoints = _ref2.breakpoints,
    type = _ref2.type,
    isH5MappingAppStyle = _ref2.isH5MappingAppStyle;
  var appStyle = useSelectAppTargetStyle({
    size: size
  });
  return addBreakpointMedia(function () {
    return objectDeepMerging(getCurrentVariantAndSizeStyle({
      size: size,
      type: type
    }), {
      root: {
        fontFamily: 'inherit',
        '& .mantine-ScrollArea-scrollbar, & .gui-mantine-rtl-ScrollArea-scrollbar': {
          padding: '2px 4px'
        },
        '& .mantine-ScrollArea-thumb, & .gui-mantine-rtl-ScrollArea-thumb': {
          background: 'var(--gui-color-divider-5)',
          filter: 'none',
          minWidth: '4px !important',
          maxWidth: '4px !important',
          borderRadius: '2px'
        }
      },
      input: _defineProperty(_defineProperty({
        fontFamily: 'inherit',
        border: "var(".concat(RootVariable.SELECT_BORDER_WIDTH, ") solid var(").concat(RootVariable.SELECT_BORDER_COLOR, ")"),
        borderRadius: "var(".concat(RootVariable.SELECT_RADIUS, ")"),
        minHeight: "var(".concat(RootVariable.SELECT_HEIGHT, ")"),
        height: "var(".concat(RootVariable.SELECT_HEIGHT, ")"),
        color: "var(".concat(RootVariable.SELECT_COLOR, ")"),
        fontSize: "var(".concat(RootVariable.SELECT_FONT_SIZE, ")"),
        fontWeight: "var(".concat(RootVariable.SELECT_FONT_WEIGHT, ")"),
        background: "var(".concat(RootVariable.SELECT_BG, ")"),
        padding: "0 var(".concat(RootVariable.SELECT_BASE_PADDING, ")"),
        paddingRight: "calc(var(".concat(RootVariable.SELECT_RIGHT_SECTION_SAFE_GAP, ") + var(").concat(RootVariable.SELECT_RIGHT_SECTION_ICON_SIZE, ") + var(").concat(RootVariable.SELECT_BASE_PADDING, "))"),
        paddingLeft: hasLeft && "calc(var(".concat(RootVariable.SELECT_ICON_SAFE_GAP, ") + var(").concat(RootVariable.SELECT_ICON_SIZE, ") + var(").concat(RootVariable.SELECT_BASE_PADDING, ")) !important"),
        '&::placeholder': {
          color: "var(".concat(RootVariable.SELECT_PLACEHOLDER_COLOR, ")"),
          fontSize: "var(".concat(RootVariable.SELECT_PLACEHOLDER_FONT_SIZE, ")"),
          fontWeight: "var(".concat(RootVariable.SELECT_PLACEHOLDER_FONT_WEIGHT, ")")
        },
        '&[aria-invalid="true"]::placeholder': {
          color: "var(".concat(RootVariable.SELECT_INVALID_PLACEHOLDER_COLOR, ")")
        },
        '&:disabled::placeholder': {
          color: "var(".concat(RootVariable.SELECT_DISABLED_PLACEHOLDER_COLOR, ")")
        },
        '@media(hover:hover)': _defineProperty(_defineProperty({}, "&:hover:not([data-mantine-stop-propagation=\"true\"]):not(:disabled):not([aria-invalid=\"true\"])+.".concat(getRef('rightSection')), {
          color: "var(".concat(RootVariable.SELECT_HOVER_RIGHT_SECTION_COLOR, ")")
        }), '&:hover:not(:disabled):not([disabled]):not([aria-invalid="true"])', {
          color: "var(".concat(RootVariable.SELECT_HOVER_COLOR, ")"),
          background: "var(".concat(RootVariable.SELECT_HOVER_BG, ")"),
          borderColor: "var(".concat(RootVariable.SELECT_HOVER_BORDER_COLOR, ")")
        }),
        '&:focus:not([aria-invalid="true"])': {
          color: "var(".concat(RootVariable.SELECT_FOCUS_COLOR, ")"),
          background: "var(".concat(RootVariable.SELECT_FOCUS_BG, ")"),
          borderColor: "var(".concat(RootVariable.SELECT_FOCUS_BORDER_COLOR, ")")
        },
        '&[data-mantine-stop-propagation="true"]': {
          color: "var(".concat(RootVariable.SELECT_ACTIVE_COLOR, ")"),
          background: "var(".concat(RootVariable.SELECT_ACTIVE_BG, ")"),
          borderColor: "var(".concat(RootVariable.SELECT_ACTIVE_BORDER_COLOR, ")")
        },
        '&[aria-invalid="true"]': {
          color: "var(".concat(RootVariable.SELECT_INVALID_COLOR, ")"),
          background: "var(".concat(RootVariable.SELECT_INVALID_BG, ")"),
          borderColor: "var(".concat(RootVariable.SELECT_INVALID_BORDER_COLOR, ")")
        },
        '&:disabled, &[disabled]': {
          color: "var(".concat(RootVariable.SELECT_DISABLED_COLOR, ")"),
          background: "var(".concat(RootVariable.SELECT_DISABLED_BG, ")"),
          borderColor: "var(".concat(RootVariable.SELECT_DISABLED_BORDER_COLOR, ")"),
          opacity: 1
        }
      }, "&:disabled+.".concat(getRef('rightSection'), ", &[disabled]+.").concat(getRef('rightSection')), {
        color: "var(".concat(RootVariable.SELECT_DISABLED_RIGHT_SECTION_COLOR, ")")
      }), "&[data-mantine-stop-propagation=\"true\"]+.".concat(getRef('rightSection')), _defineProperty({
        color: "var(".concat(RootVariable.SELECT_ACTIVE_RIGHT_SECTION_COLOR, ")")
      }, "&>.".concat(getRef('rightSectionIcon')), {
        transform: 'rotate(180deg)',
        transformOrigin: 'center'
      })),
      rightSection: {
        ref: getRef('rightSection'),
        width: 'fit-content',
        color: "var(".concat(RootVariable.SELECT_RIGHT_SECTION_COLOR, ")"),
        paddingRight: "var(".concat(RootVariable.SELECT_BASE_PADDING, ")"),
        paddingLeft: "var(".concat(RootVariable.SELECT_RIGHT_SECTION_SAFE_GAP, ")"),
        pointerEvents: 'none'
      },
      rightSectionIcon: {
        ref: getRef('rightSectionIcon'),
        width: "var(".concat(RootVariable.SELECT_RIGHT_SECTION_ICON_SIZE, ")"),
        height: "var(".concat(RootVariable.SELECT_RIGHT_SECTION_ICON_SIZE, ")")
      },
      dropdown: {
        boxShadow: '0px 7px 20px rgba(13, 31, 66, 0.07)',
        border: 'none',
        overflow: 'hidden',
        borderRadius: "var(".concat(RootVariable.SELECT_DROPDOWN_RADIUS, ")"),
        borderTop: "var(".concat(RootVariable.SELECT_DROPDOWN_BOTTOM_SAFE_GAP, ") solid var(").concat(RootVariable.SELECT_DROPDOWN_BG, ")"),
        borderBottom: "var(".concat(RootVariable.SELECT_DROPDOWN_BOTTOM_SAFE_GAP, ") solid var(").concat(RootVariable.SELECT_DROPDOWN_BG, ")"),
        background: "var(".concat(RootVariable.SELECT_DROPDOWN_BG, ")"),
        '& .mantine-ScrollArea-scrollbar, & .gui-mantine-rtl-ScrollArea-scrollbar': {
          padding: '2px 0 2px 4px'
        },
        '& .mantine-ScrollArea-scrollbar[data-orientation="vertical"], & .gui-mantine-rtl-ScrollArea-scrollbar[data-orientation="vertical"]': {
          width: '8px'
        },
        '& .mantine-ScrollArea-thumb, & .gui-mantine-rtl-ScrollArea-thumb': {
          background: 'var(--gui-color-divider-5)',
          filter: 'none',
          minWidth: '4px !important',
          maxWidth: '4px !important',
          borderRadius: '2px'
        }
      },
      itemsWrapper: {
        border: 'none',
        padding: "0 var(".concat(RootVariable.SELECT_DROPDOWN_PADDING, ") 0 var(").concat(RootVariable.SELECT_DROPDOWN_PADDING, ")")
      },
      item: {
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
        color: "var(".concat(RootVariable.SELECT_ITEM_COLOR, ")"),
        height: "var(".concat(RootVariable.SELECT_ITEM_HEIGHT, ")"),
        fontFamily: 'inherit',
        fontSize: "var(".concat(RootVariable.SELECT_ITEM_FONT_SIZE, ")"),
        fontWeight: "var(".concat(RootVariable.SELECT_ITEM_FONT_WEIGHT, ")"),
        padding: "0 var(".concat(RootVariable.SELECT_ITEM_BASE_PADDING, ")"),
        paddingRight: "calc(var(".concat(RootVariable.SELECT_ITEM_ACTIVE_ICON_SAFE_GAP, ") + var(").concat(RootVariable.SELECT_ITEM_ACTIVE_ICON_SIZE, ") + var(").concat(RootVariable.SELECT_ITEM_BASE_PADDING, "))"),
        margin: "var(".concat(RootVariable.SELECT_ITEM_COL_GAP, ") 0"),
        borderRadius: "var(".concat(RootVariable.SELECT_ITEM_RADIUS, ")"),
        '[dir="rtl"] &[data-selected]::after': {
          borderRight: "none",
          borderLeft: "2px solid ".concat('var(--gui-color-icon-5)')
        },
        '&[data-selected]': {
          background: "var(".concat(RootVariable.SELECT_ITEM_SELECTED_BG, ")"),
          color: "var(".concat(RootVariable.SELECT_ITEM_SELECTED_COLOR, ")"),
          position: 'relative'
        },
        '@media(hover:hover)': {
          '&[data-hovered]': {
            background: "var(".concat(RootVariable.SELECT_ITEM_HOVER_BG, ")"),
            color: "var(".concat(RootVariable.SELECT_ITEM_HOVER_COLOR, ")")
          },
          '&:hover[data-selected]': {
            background: "var(".concat(RootVariable.SELECT_ITEM_HOVER_BG, ")")
          }
        }
      },
      icon: {
        left: "var(".concat(RootVariable.SELECT_BASE_PADDING, ")"),
        width: 'fit-content',
        color: "var(".concat(RootVariable.SELECT_ICON_COLOR, ")")
      },
      iconElement: _defineProperty({
        width: "var(".concat(RootVariable.SELECT_ICON_SIZE, ") !important"),
        minWidth: "var(".concat(RootVariable.SELECT_ICON_SIZE, ") !important"),
        height: "var(".concat(RootVariable.SELECT_ICON_SIZE, ") !important"),
        minHeight: "var(".concat(RootVariable.SELECT_ICON_SIZE, ") !important"),
        fontSize: "var(".concat(RootVariable.SELECT_ICON_SIZE, ") !important")
      }, "&.".concat(getRef('disabled')), {
        color: "var(".concat(RootVariable.SELECT_DISABLED_ICON_COLOR, ")")
      }),
      separator: {
        padding: '8px 0'
      },
      separatorLabel: {
        padding: "0 var(".concat(RootVariable.SELECT_ITEM_BASE_PADDING, ")"),
        color: 'var(--gui-color-text-3)',
        fontSize: '14px',
        fontWeight: 500,
        marginTop: '0 !important',
        '&::before': {
          display: 'none'
        },
        '&::after': {
          display: 'none'
        }
      },
      nothingFound: {
        paddingTop: 0,
        paddingBottom: 0
      },
      wrapper: {},
      invalid: {},
      disabled: {
        ref: getRef('disabled')
      },
      withIcon: {},
      error: {
        fontFamily: 'inherit',
        fontSize: '12px',
        color: 'var(--gui-color-funct-3)',
        fontWeight: 400,
        lineHeight: 1.2,
        marginTop: '8px'
      },
      label: {
        fontFamily: 'inherit',
        fontSize: '14px',
        color: 'var(--gui-color-text-1)',
        fontWeight: 400,
        lineHeight: 1.2,
        marginBottom: '8px'
      },
      require: {},
      description: {
        fontFamily: 'inherit'
      }
    });
  }, {}, [].concat(_toConsumableArray(isH5MappingAppStyle ? [{
    maxWidth: 'md',
    styles: appStyle
  }] : []), _toConsumableArray(breakpoints)), ThemeBreakpoints);
});
var useSelectItemStyle = createStyles(function (_, _ref3) {
  var iconPosition = _ref3.iconPosition,
    breakpoints = _ref3.breakpoints;
  return addBreakpointMedia(function () {
    return {
      root: {
        position: 'relative',
        display: 'flex'
      },
      icon: _objectSpread2({
        width: "20px !important",
        height: "20px !important",
        fontSize: "20px !important"
      }, iconPosition === 'left' ? {
        marginRight: '8px'
      } : {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        right: '8px'
      })
    };
  }, {}, breakpoints, ThemeBreakpoints);
});
var useSelectDynamicStyle = function useSelectDynamicStyle(params) {
  var fz = params.fz,
    fw = params.fw;
  return _defineProperty(_defineProperty({}, RootVariable.SELECT_FONT_WEIGHT, fw), RootVariable.SELECT_FONT_SIZE, fz && (isString(fz) ? fz : "".concat(fz, "px")));
};

export { useSelectDynamicStyle, useSelectItemStyle, useSelectStyle };
//# sourceMappingURL=GateSelect.style.js.map
